import { isEmpty, keys, values, sortBy } from 'lodash-es';
import { isUnified } from '../../utils/helpers';

const setItem = (id, label, store, disabled = false, idValue = undefined) => ({
  id: idValue || id,
  value: id,
  label,
  disabled,
  store,
});

const allCategories = setItem(0, 'All Categories');

const allNonGamesVirtualCategory = setItem(100500, 'All Non Games');

const umbrellaCategories = (gamesNonGames) => {
  if (gamesNonGames === 'non_games') {
    return {
      google_play: { family: 1001 },
      itunes_connect: { kids: 36001000 },
    };
  }
  if (gamesNonGames === 'games') {
    return {
      google_play: { games: 38 },
      itunes_connect: { games: 6014 },
    };
  }
  return {
    google_play: { family: 1001, games: 38 },
    itunes_connect: { games: 6014, kids: 36001000 },
  };
};


const getUmbrellaCategoryId = (store, categoryName, gamesNonGames) =>
  umbrellaCategories(gamesNonGames)[store][categoryName.toLowerCase()];

const categoriesListByStore = ({
  store, gamesNonGames, excludedCategories,
}) => {
  let catByStore = MULTILEVEL_CATEGORIES[store];

  const storeGamesCat = store === 'itunes_connect' ? 6014 : 38;

  if (!isEmpty(excludedCategories)) {
    catByStore = catByStore.filter(c => excludedCategories.every(e => c[0] !== e));
  }

  if (gamesNonGames === 'non_games') {
    return catByStore.filter(c => c[0] !== storeGamesCat);
  }

  if (gamesNonGames === 'games') {
    const filteredCat = catByStore.filter(c => c[0] === storeGamesCat);
    const gameslist = !isEmpty(filteredCat) && filteredCat[0][1].Games;
    return keys(gameslist).map(g => [g, gameslist[g]]);
  }

  return catByStore;
};

export const buildCategoryList = (setters) => {
  let rootMenuItems = [];

  const {
    store,
    excludeOverall,
    enableUmbrellaCategories,
    gamesNonGames,
    overallCategoryCustomName,
    includeAllCategories,
    withAllNonGamesVirtualCategory,
  } = setters;

  const isGamesNotUnified = gamesNonGames === 'games' && !isUnified(store);

  categoriesListByStore(setters).forEach(
    (category) => {
      const hasSubcaterories = typeof category[1] === 'object';
      const isDefaultCategory = DEFAULT_CATEGORIES[store] === category[0];

      if (hasSubcaterories) {
        const nodeText = keys(category[1])[0];
        const subCategories = values(category[1])[0];

        const subMenuItems = keys(subCategories).map(subCategory => setItem(
          parseInt(subCategory, 10),
          subCategories[subCategory],
          store,
        ));
        const umbrellaCID = getUmbrellaCategoryId(store, nodeText, gamesNonGames);
        const withUmbrellaCategory = [
          setItem(
            umbrellaCID,
            `All ${nodeText}`,
            store,
          ),
          ...subMenuItems,
        ];
        const subMenuData = enableUmbrellaCategories && umbrellaCID
          ? withUmbrellaCategory : subMenuItems;

        rootMenuItems.push(setItem(
          subMenuData,
          nodeText,
          store,
          false,
          `${store}-${nodeText}`,
        ));
      } else if (isDefaultCategory || !(excludeOverall && isDefaultCategory)) {
        rootMenuItems.push(setItem(
          category[0],
          !(excludeOverall && isDefaultCategory)
            ? category[1]
            : (overallCategoryCustomName || category[1]),
          store,
          category.disabled,
        ));
      }
    });

  if (isGamesNotUnified) {
    const umbrellaCID = getUmbrellaCategoryId(store, 'games', gamesNonGames);
    rootMenuItems.unshift(
      setItem(
        umbrellaCID,
        'All Games',
        store,
      ));
  }

  if (includeAllCategories) {
    rootMenuItems.unshift(allCategories);
  }

  if (withAllNonGamesVirtualCategory) {
    rootMenuItems = [...rootMenuItems.slice(0, 1), allNonGamesVirtualCategory, ...rootMenuItems.slice(1)];
  }

  return rootMenuItems;
};

const buildUnifiedCategoryList = setters => sortBy([
  ...buildCategoryList({ ...setters, store: 'itunes_connect' }),
  ...buildCategoryList({ ...setters, store: 'google_play' }),
], 'label');

export const decorateCategoriesList = (setters) => {
  const { store } = setters;

  if (isUnified(store)) {
    return buildUnifiedCategoryList();
  }

  return buildCategoryList(setters);
};
